import {DialogStyle} from "../../../../Utils/UI/GlobalStyles.js";
import React, {useState} from "react";
import {Button, Column, Row, Select, Text, TextArea} from "react-vcomponents";
import {ScrollView} from "react-vscrollview";

const textTransform_options = [
	{name: "Extract titles (markdown, small)", value: "extractTitles_markdown_small"},
] as const;
type TextTransform = typeof textTransform_options[number]["value"];
function ApplyTextTransform(text: string, transform: TextTransform): string {
	if (transform == "extractTitles_markdown_small") {
		return text.split("\n").map(line=>{
			if (line.startsWith("### ")) return "-# \\* " + line.replace("### ", "");
			return null;
		}).filter(a=>a != null).join("\n");
	}
	return text;
}

export const TextTransformToolsUI = ()=>{
	const [transform, setTransform] = useState<TextTransform>("extractTitles_markdown_small");
	const [leftText, setLeftText] = useState("");
	const [rightText, setRightText] = useState("");
	return (
		<Column style={DialogStyle({width: 800})}>
			<Row center mb={5}>
				<Text mr={5}>Transform:</Text>
				<Select displayType="button bar" options={textTransform_options} value={transform} onChange={val=>setTransform(val)}/>
				<Button ml="auto" text="Apply" onClick={()=>{
					setRightText(ApplyTextTransform(leftText, transform));
				}}/>
			</Row>
			<Row style={{flex: 1, gap: 10}}>
				<ScrollView style={{flex: 1}}>
					<TextArea style={{border: "1px solid black"}} autoSize={true} {...{minRows: 5} as any}
						value={leftText} onChange={val=>setLeftText(val)}/>
				</ScrollView>
				<ScrollView style={{flex: 1}}>
					<TextArea style={{border: "1px solid black"}} autoSize={true} {...{minRows: 5} as any}
						value={rightText} onChange={val=>setRightText(val)}/>
				</ScrollView>
			</Row>
		</Column>
	);
};